import React from "react";
import { iconUrlFromCode } from "../Services/WeatherService";

// swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper";

import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/pagination";
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

const Forecast = ({ title, items, unit, query }) => {
  let DisplayUnit = unit === "imperial" ? "F" : "C";
  return (
    <div>
      <div className="flex flex-col justify-start mt-6">
        <p className="text-white font-medium uppercase ">
          {title} For{" "}
          <span className="text-cyan-300 font-semibold uppercase ">
            {query}
          </span>
        </p>
      </div>
      <hr className="my-2 text-white text-2xl" />
      <div className="flex flex-row items-center justify-between text-white">
        <Swiper
          freeMode={true}
          grabCursor={true}
          modules={[FreeMode]}
          slidesPerView={5}
          spaceBetween={10}
          loop={true}
          navigation
          className="flex flex-row item-center justify-between overflow-scroll text-white "
        >
          {items.map((item, ind) => (
            <SwiperSlide
              key={ind}
              className="flex flex-col items-center min-w-max text-white border rounded-lg bg-gradient-to-r from-blue-400 via-blue-400 to-blue-300 shadow-sm shadow-blue-400 overflow-hidden"
            >
              <h2 className="font-light text-sm mt-2">{item.title}</h2>
              <img
                src={iconUrlFromCode(item.icon)}
                alt="no-weather-icon"
                className="w-20 my-1 "
              />
              <p className="font-medium mb-4">
                {item.temp} ° {DisplayUnit}
              </p>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Forecast;
